module.exports = __webpack_public_path__ + "static/media/Icond-1.54934242.svg";